import './styles.scss'
import React from 'react'
import { SelectWithLabel } from 'components/Form'
import { lang } from 'utils/helpers'
import { channels as channelsNewApi } from 'api'

/**
 * SelectChannelRedirect
 * @param {object} props
 * @param {String} props.label
 * @param {String} props.placeholder
 */
const SelectChannelRedirect = ({ label, placeholder, description, onChange, value, required } ) => {

  const [redirectableChannels, setRedirectableChannels] = React.useState([])
  
  React.useEffect(()=>{
    const fetchRedirectableChannels = async () => {
      try {
        const { data } = await channelsNewApi.getChannelsToRedirect()
        setRedirectableChannels(data.map(obj => ({ value: obj._id, label: obj.value.name })))
      } catch (e) {
        console.error('e: ', e)
      }
    }
    fetchRedirectableChannels()
  }, [])

  return (
    <div className='channel-field select'>
      {label && <label>{lang(label)} <span className='required'>{required ? '*' : ''}</span></label>}
      <div className='field-content grid grid--small'>
        <SelectWithLabel
          placeholder={placeholder || lang('dashboard_select')}
          options={redirectableChannels}
          onChange={(value) => onChange(value.value)}
          value={value ? redirectableChannels.find(it => it.value === value) : ''}
        />
        {description && <p className='description'>{lang(description)}</p>}
      </div>
    </div>
  )
}

export default SelectChannelRedirect
